module.exports = __webpack_public_path__ + "static/img/content2.8c897195.png";